import { render, staticRenderFns } from "./CountDiseaseByDepartmentDiagram.vue?vue&type=template&id=45accf08&scoped=true&"
import script from "./CountDiseaseByDepartmentDiagram.vue?vue&type=script&lang=js&"
export * from "./CountDiseaseByDepartmentDiagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45accf08",
  null
  
)

export default component.exports